import { useIntl } from "react-intl";

import { Tag } from "../../../../../atoms/tag";
import {
  DataFormCloseButton,
  DataFormHeaderLayout,
  DataFormTitle,
  DataFormToolbarDefaultButtons,
  DataFormToolbarLayout,
} from "../../../../../data-form";
import { useDataFormPreferencesContext } from "../../context";
import { useGetProfileFromPreferences } from "../../hooks/get-profile-from-preference";
import { type DataTablePreferencesBrowseType } from "../../schema";
import {
  DataFormPreferenceApplyAction,
  DataFormPreferenceApplyButton,
} from "./data-form-preference-apply";
import {
  DataFormPreferenceDeleteAction,
  DataFormPreferenceDeleteButton,
} from "./data-form-preference-delete";
import {
  DataFormPreferenceOverrideAction,
  DataFormPreferenceOverrideButton,
} from "./data-form-preference-override";

export function DataFormHeader() {
  const intl = useIntl();

  const { isEditing, entity, mode, setMode, setEntity } =
    useDataFormPreferencesContext();

  const profile = useGetProfileFromPreferences();

  const isActiveProfile = profile?.id === entity?.id;

  return (
    <DataFormHeaderLayout>
      <div className="contents grow">
        <div className="mr-2">
          <DataFormCloseButton
            href={undefined}
            onClick={() => {
              setEntity(null);
              setMode("detail");
            }}
          />
        </div>

        <DataFormTitle<DataTablePreferencesBrowseType>
          titleMapper={(entity) => entity.name}
        />

        {isActiveProfile && (
          <Tag inverse={true}>
            {intl.formatMessage({
              id: "data-form.preferences.active",
              defaultMessage: "Aktivní",
            })}
          </Tag>
        )}
      </div>

      {mode === "detail" && (
        <DataFormToolbarLayout>
          <DataFormToolbarDefaultButtons showDelete={false} />

          {!isEditing && (
            <>
              {!isActiveProfile && (
                <>
                  <DataFormPreferenceApplyButton />

                  <DataFormPreferenceOverrideButton />
                </>
              )}

              <DataFormPreferenceDeleteButton />
            </>
          )}
        </DataFormToolbarLayout>
      )}

      {mode === "override" && <DataFormPreferenceOverrideAction />}

      {mode === "apply" && <DataFormPreferenceApplyAction />}

      {mode === "delete" && <DataFormPreferenceDeleteAction />}
    </DataFormHeaderLayout>
  );
}
